import React, {useEffect, useState} from "react";
import "./logoDropDown.css";
import logoS from "../../assets/images/s-white-on-black-logo.png";
import {useRef} from "react-with-hooks";
import CTAButton from "../utils/Button/CTAButton";

function LogoDropDown({ activeItems = [], animation }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuTop, setMenuTop] = useState(0);
    const logoRef = useRef(null);

    useEffect(() => {
        if (logoRef.current) {
            const rect = logoRef.current.getBoundingClientRect();
            setMenuTop(rect.bottom + 10);
        }
    }, [menuOpen]);
    return (
        <>
            {menuOpen && (
                <div
                    className="overlay"
                    onClick={() => setMenuOpen(false)}
                />
            )}

            <div
                style={{
                    width: "clamp(1px, 23.35vw, 100px)",
                    height: "100%",
                    maxHeight: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <img
                    className={`${animation && 'fade-in'}`}
                    ref={logoRef}
                    src={logoS}
                    alt="logo"
                    style={{
                        paddingBottom: "5px",
                        paddingInline: "1px",
                        borderBottom: "2px solid #B08D57",
                        height: `clamp(45px, 6.8vh, 68px)`,
                        objectFit: `contain`,
                        zIndex: "1001",
                        cursor: "pointer",
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen((prev) => !prev);
                    }}
                />
            </div>

            <div
                className={`logo-menu-container ${menuOpen ? "show" : ""}`}
                style={{
                    position: "fixed",
                    margin: "0 auto",
                    width: '90vw',
                    maxWidth: '400px',
                    top: menuTop,
                    zIndex: 1001,
                    display: "flex",
                    justifyContent: "flex-end"
                }}
            >
                <div
                    className={`logo-menu ${menuOpen ? "show" : ""}`}
                    style={{
                        fontFamily: "Open Sans",
                        fontWeight: 800
                    }}
                >
                    <CTAButton
                        onClick={() => window.location.href = `${process.env.REACT_APP_COM_URL}/aboutus`}
                        active={activeItems.includes('Schmodel')}
                        text="Schmodel"
                    />
                    <CTAButton
                        onClick={() => window.location.href = `${process.env.REACT_APP_CLUB_URL}/aboutus`}
                        active={activeItems.includes('.club')}
                        text=".club"
                    />
                    <CTAButton
                        onClick={() => window.location.href = `${process.env.REACT_APP_SHOP_URL}/aboutus`}
                        active={activeItems.includes('.shop')}
                        text=".shop"
                    />
                    {/*<CTAButton*/}
                    {/*    onClick={() => window.location.href = `${process.env.REACT_APP_STUDIO_URL}/aboutus`}*/}
                    {/*    active={activeItems.includes('.studio')}*/}
                    {/*    text=".studio"*/}
                    {/*/>*/}
                </div>
            </div>
        </>
    );
}

export default LogoDropDown;
